export default "__VITE_ASSET__e2af86a8__"